/* eslint-disable camelcase */
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { AuthUserDetails, getCookieTokens, getUserInfoFromTokens, useLocalStorage } from '@schemeserve/global-utils';
import { isANonAuthPage } from 'src/context/Auth';
import smartlookClient from 'smartlook-client';
import * as O from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';
import setUpFeautreFlags, {
  buildUserContext,
  getGrowthbookProvider,
} from 'src/services/featureFlags';
import createFeatureDecisions from 'src/services/feauterDecisions';
import {
  initFathom,
  initDelighted,
  initGoogleAnalyticsV3,
  initGoogleAnalyticsV4,
  initGoogleTagManager,
  initFacebookPixel,
  initLinkedinPixel,
  initHubspot,
  initSmartlook,
} from './initTrackingScripts';

type TrackingProps = {
  // siteSettings: {
  //   google_tagmanager_id?: string;
  //   google_analytics_id?: string;
  //   google_analytics_version?: 3 | 4;
  //   hubspot_id?: string;
  //   facebook_pixel_id?: string;
  //   linkedin_id?: string;
  // };
  user: {
    Username: string;
    UserId: string;
    accessGroup: string;
    AccessGroup: string;
    AccountId: string;
    MasterAccountId: string;
    siteUrl: string;
  };
};

const featureFlags = await setUpFeautreFlags(
  getGrowthbookProvider(),
  buildUserContext,
);

function Tracking({ user }: TrackingProps): null {
  const { getItem } = useLocalStorage();
  const siteSettings = getItem('ssSiteSettings') as {
    [key: string]: string;
  };
  const featuresDecisions = createFeatureDecisions(featureFlags);
  const enableSmartLook = featuresDecisions.isSmartlookEnabled();

  const userInfo = pipe(
    getCookieTokens(),
    getUserInfoFromTokens,
    O.getOrElse(() => ({}) as AuthUserDetails),
  );

  /*
  const accessToken = getItem('ssAccess') as string;
  const jwtData = jwt.decode(accessToken) || {};
  */
  const {
    PrimaryEmail: primaryEmail,
    Username: username,
    MasterAccountId: masterAccountId,
    AccountId: accountId,
    AccessGroup: accessGroup,
    MasterUrl: masterUrl,
    UserId: userId,
  } = userInfo;
  useEffect(() => {
    if (siteSettings) {
      const {
        google_tagmanager_id: googleTagManagerId,
        google_analytics_id: googleAnalyticsId,
        google_analytics_version: googleAnalyticsVersion,
        hubspot_id: hubspotId,
        facebook_pixel_id: facebookPixelId,
        linkedin_id: linkedinId,
      } = siteSettings;

      const integerGoogleAnalyticsVersion = parseInt(
        googleAnalyticsVersion,
        10,
      );

      // Fathom
      initFathom(); // SchemeServe Global (client can't configure or turn off)

      if (enableSmartLook) {
        console.log('enabling smartlook');
        // Smartlook
        initSmartlook(); // SchemeServe Global (client can't configure or turn off)
      }

      // Delighted
      if (accountId === masterAccountId && !isANonAuthPage()) {
        initDelighted({ user, email: primaryEmail, accountId }); // SchemeServe Global (client can't configure or turn off)
      }

      // Google Analytics
      if (googleAnalyticsVersion && googleAnalyticsId) {
        if (integerGoogleAnalyticsVersion === 3) {
          initGoogleAnalyticsV3(googleAnalyticsId);
        } else if (integerGoogleAnalyticsVersion === 4) {
          initGoogleAnalyticsV4(googleAnalyticsId);
        }
      }

      // Google Tag Manager
      googleTagManagerId && initGoogleTagManager(googleTagManagerId);

      // Facebook Pixel
      facebookPixelId && initFacebookPixel(facebookPixelId);

      // Linkedin Pixel
      linkedinId && initLinkedinPixel(linkedinId);

      // Hubspot
      hubspotId && initHubspot(hubspotId);
    }
  }, [siteSettings]);

  useEffect(() => {
    if (enableSmartLook) {
      console.log('sm record & identify');
      smartlookClient.record({
        forms: true,
        emails: true,
        ips: true,
        numbers: true,
        api: true,
      });

      smartlookClient.identify(userId, {
        email: primaryEmail,
        username,
        name: username,
        masterAccountId,
        accountId,
        accessGroup: accessGroup as unknown as string,
        masterUrl,
        uid: userId,
      });
    }
  }, [window.smartlook]);

  return null;
}

const mapStateToProps = (state) => ({
  user: state.global.user,
});

export default connect(mapStateToProps)(Tracking);
